<template>
  <div class="home">
    <div class="hero-section">
      <div class="container">
        <h1 class="hero-title">歡迎來到 Reward Swap</h1>
        <p class="hero-subtitle">健康集點通</p>
        
        <div class="entry-buttons">
          <a @click.prevent="goToUser" href="#" class="feature-link primary">
            <span class="feature-link-icon">
              <Icon name="shopping-cart" library="lucide" class="w-6 h-6 text-white" />
            </span>
            前台用戶介面
          </a>
          
          <a @click.prevent="goToAdmin" href="#" class="feature-link secondary">
            <span class="feature-link-icon">
              <Icon name="settings" library="lucide" class="w-6 h-6 text-white" />
            </span>
            管理後台
          </a>
          
          <router-link to="/sample" class="feature-link sample">
            <span class="feature-link-icon">
              <Icon name="file-text" library="lucide" class="w-6 h-6 text-white" />
            </span>
            Sample 範例
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Icon from '@/components/icons/Icon.vue'
import { authService } from '@/services/authService'
import { useRouter } from 'vue-router'

const router = useRouter()

/**
 * 進入前台用戶介面
 * 清除當前登入狀態，確保從頭開始前台登入流程
 */
const goToUser = () => {
  // 清除現有登入狀態
  authService.removeToken()
  
  // 導向前台登入頁面
  router.push('/login')
}

/**
 * 進入管理後台
 * 清除當前登入狀態，確保從頭開始管理後台登入流程
 */
const goToAdmin = () => {
  // 清除現有登入狀態
  authService.removeToken()
  
  // 導向管理後台登入頁面
  router.push('/admin/login')
}
</script>

<style scoped>
/* 使用統一的元件系統，僅保留頁面特定樣式 */

/* 首頁特定的全屏佈局 */
.home {
  padding: 0;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Hero區域高度調整 */
.hero-section {
  height: 100vh;
}

/* 首頁特定的按鈕增強效果 */
.feature-link {
  min-width: 180px;
  justify-content: center;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  font-size: var(--text-lg);
  padding: var(--spacing-lg) var(--spacing-2xl);
}

.feature-link:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
}

/* 首頁按鈕顏色變體 */
.feature-link.primary {
  background: var(--success-color);
  color: white;
}

.feature-link.primary:hover {
  background: var(--success-hover);
}

.feature-link.secondary {
  background: var(--danger-color);
  color: white;
}

.feature-link.secondary:hover {
  background: var(--danger-hover);
}

.feature-link.sample {
  background: var(--primary-color);
  color: white;
}

.feature-link.sample:hover {
  background: var(--primary-hover);
}

/* 響應式調整覆蓋 */
@media (max-width: 768px) {
  .entry-buttons {
    flex-direction: column;
    align-items: center;
    gap: var(--spacing-md);
  }
  
  .feature-link {
    width: 100%;
    max-width: 280px;
    padding: var(--spacing-lg) var(--spacing-2xl);
    font-size: var(--text-base);
  }
}

@media (max-width: 480px) {
  .feature-link {
    padding: var(--spacing-md) var(--spacing-xl);
    min-width: 200px;
    max-width: 250px;
  }
}

@media (max-width: 360px) {
  .feature-link {
    font-size: var(--text-sm);
    padding: var(--spacing-sm) var(--spacing-lg);
  }
}
</style>
